// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalculatorFilledSvg from "@fishx/icons-svg/es/asn/CalculatorFilled";
import FishxIcon from '../components/FishxIcon';

var CalculatorFilled = function CalculatorFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalculatorFilledSvg
  }));
};

CalculatorFilled.displayName = 'CalculatorFilled';
export default React.forwardRef(CalculatorFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CalculatorFilled.js
// module id = 2137
// module chunks = 0